import { render, staticRenderFns } from "./IconMinimap.vue?vue&type=template&id=12bbedc4&scoped=true&"
import script from "./IconMinimap.vue?vue&type=script&lang=js&"
export * from "./IconMinimap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bbedc4",
  null
  
)

export default component.exports